import 'core-js/stable'
import { MountApplicationToReactDOM } from './cra-custom-mounts'
import MOUNT_DATA from './mounts.json'
import App from './App'
import { tealiumBootCallback } from './tealium'

const MOUNT_KEY = process.env.REACT_APP_MOUNT_KEY || 'default'

MountApplicationToReactDOM(
  document.getElementById('root'),
  App,
  MOUNT_DATA,
  MOUNT_KEY,
  tealiumBootCallback
);

